import React from "react";

// Styles
import {
	createStyles,
	Theme,
	makeStyles,
	useTheme,
} from "@material-ui/core/styles";

// MUI
import {
	AppBar,
	Toolbar,
	Fab,
	SvgIcon,
	useMediaQuery,
} from "@material-ui/core";

// Components
import { GlassPaper } from "../../GlassPaper/GlassPaper";

// Icons
import { ReactComponent as Access } from "../../../static/svg/access.svg";
import { ReactComponent as Air } from "../../../static/svg/air.svg";
import { ReactComponent as Climate } from "../../../static/svg/climate.svg";
import { ReactComponent as Schedule } from "../../../static/svg/schedule.svg";
import { ReactComponent as Lighting } from "../../../static/svg/lighting.svg";
import { ReactComponent as Tenant } from "../../../static/svg/tenant.svg";

// Router
import { useHistory } from "react-router";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		appBar: {
			top: "auto",
			bottom: 0,
		},
		toolbar: {
			display: "flex",
			justifyContent: "space-evenly",
			padding: "1rem",
		},
		fabButton: {
			margin: "0 auto",
		},
	})
);

export const SpaceAppBarBottom: any = ({
	access,
	iaq,
	lights,
	schedule,
	thermostat,
	density,
}: any) => {
	const classes = useStyles();

	const history = useHistory();
	const { pathname, search } = history?.location;

	const theme = useTheme();
	const mobile = useMediaQuery(theme.breakpoints.only("xs"));

	return (
		<AppBar position="fixed" color="transparent" className={classes.appBar}>
			<GlassPaper
				square
				style={{ position: "fixed", width: "100%", bottom: mobile ? 70 : 80 }}
			>
				<Toolbar className={classes.toolbar}>
					{Boolean(access) && (
						<Fab
							size={mobile ? "small" : "medium"}
							color={search.includes("access") ? "primary" : "default"}
							aria-label="add"
							className={classes.fabButton}
							onClick={() =>
								history.push({ pathname, search: "?component=access" })
							}
						>
							<SvgIcon>
								<Access />
							</SvgIcon>
						</Fab>
					)}

					{Boolean(iaq) && (
						<Fab
							size={mobile ? "small" : "medium"}
							color={search.includes("iaq") ? "primary" : "default"}
							aria-label="add"
							className={classes.fabButton}
							onClick={() =>
								history.push({ pathname, search: "?component=iaq" })
							}
						>
							<SvgIcon>
								<Air />
							</SvgIcon>
						</Fab>
					)}

					{Boolean(thermostat) && (
						<Fab
							size={mobile ? "small" : "medium"}
							color={search.includes("thermostat") ? "primary" : "default"}
							aria-label="add"
							className={classes.fabButton}
							onClick={() =>
								history.push({ pathname, search: "?component=thermostat" })
							}
						>
							<SvgIcon>
								<Climate />
							</SvgIcon>
						</Fab>
					)}

					{Boolean(schedule) && (
						<Fab
							size={mobile ? "small" : "medium"}
							color={search.includes("schedule") ? "primary" : "default"}
							aria-label="add"
							className={classes.fabButton}
							onClick={() =>
								history.push({ pathname, search: "?component=schedule" })
							}
						>
							<SvgIcon>
								<Schedule />
							</SvgIcon>
						</Fab>
					)}

					{Boolean(lights) && (
						<Fab
							size={mobile ? "small" : "medium"}
							color={search.includes("lights") ? "primary" : "default"}
							aria-label="add"
							className={classes.fabButton}
							onClick={() =>
								history.push({
									pathname,
									search: "?component=lights",
								})
							}
						>
							<SvgIcon>
								<Lighting />
							</SvgIcon>
						</Fab>
					)}

					{Boolean(density) && (
						<Fab
							size={mobile ? "small" : "medium"}
							color={search.includes("density") ? "primary" : "default"}
							aria-label="add"
							className={classes.fabButton}
							onClick={() =>
								history.push({
									pathname,
									search: "?component=density",
								})
							}
						>
							<SvgIcon>
								<Tenant />
							</SvgIcon>
						</Fab>
					)}
				</Toolbar>
			</GlassPaper>
		</AppBar>
	);
};
